import {
  Avatar,
  Button,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import Header from "../ui/Header";
import ViewMember from "../member/ViewMember";
import ListReceipt from "../../pages/ListReceipt";
import PendingReceipt from "../../pages/PendingReceipt";
import AddMerchant from "../forms/AddMerchant";
import { ViewMerchant } from "../merchant/ViewMerchant";
import ImportReceipt from "../../pages/ImportReceipt";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import CampaignIcon from "@mui/icons-material/Campaign";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import SettingsIcon from "@mui/icons-material/Settings";
import FeedbackIcon from "@mui/icons-material/Feedback";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import HandshakeIcon from "@mui/icons-material/Handshake";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ViewMemberDetails from "../member/ViewMemberDetails";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AddMemberForm from "../forms/AddMemberForm";
import AddReceipt from "../../pages/AddReceipt";
import { initialFormValuesNew } from "../../static-models/MemberFormData";
import { AddMerchantData } from "../../static-models/merchantFormData";
import FraudDetectSettings from "../../pages/FraudDetectSetting";
import { Admin, CustomerServiceAdmin } from "../../RoleManagement";
import { Role } from "../role/Role";
import { AdminSidebar } from "../role/AdminSidebar";
import { AddUser } from "../role/AddUser";
import { AddShopUser } from "../role/AddShopUser";
import { ViewUserProfile } from "../role/ViewUserProfile";
import { ViewShopUser } from "../role/ViewShopUser";
import { ReactComponent as Promotions } from "../../../src/assets/promotions.svg";
import { ReactComponent as Configuration } from "../../../src/assets/configuration.svg";
import { Profile } from "../profile/Profile";
import { AddAdminData } from "../../static-models/AdminFormData";
import { Finance } from "../finance/FinancePage";
import Redirected from "./Redirected";
import { useAppSelector } from "../../redux/hooks";
import { UpdateAdminData } from "../../static-models/AdminFormUpdateData";
import Sales from "../../CustomerPortal/Sales";
import RedeemCheckBox from "../../CustomerPortal/RedeemCheckBox";
import MemberRedemption from "../../CustomerPortal/MemberRedemption";
import { constant } from "../../constants";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddCardIcon from "@mui/icons-material/AddCard";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ViewReportDetails from "../finance/ViewReportDetails";
import AdminVoucherTransaction from "../role/AdminVoucherTransaction";
import ViewPVReportDetails from "../finance/ViewPVReportDetail";
import { AddUserAccess } from "../UserAccess/AddUserAccess";
import { UpdateUserAccess } from "../UserAccess/UpdateUserAccess";
import PhysicalVoucherUpload from "../../pages/PhysicalVoucherUpload";
import AddPhysicalVoucher from "../../pages/AddPhysicalVoucher";
import EvoucherTab from "../MerchantPortalUI/EvoucherTab";
import EVoucherTransaction from "../MerchantPortalUI/EVoucherTransaction";
import PhysicalEvoucherNew from "../MerchantPortalUI/PhysicalEvoucherNew";
import SalesReports from "../../CustomerPortal/SalesReports";
import CorporateLogs from "../member/CorporateLogs";
import ViewCorporateUser from "../member/ViewCorporateUser";
import AddPromotionsForm from "../merchant/AddPromotionsForm";
import FlashSaleNew from "../MerchantPortalUI/FlashSaleNew";
import DealsNew from "../MerchantPortalUI/DealsNew";
import NewProfile from "../../pages/NewProfile";
import UpdateProfile from "../../pages/UpdateProfile";
import CloseIcon from "@mui/icons-material/Close";
import useButtonStyles from "../../styles/useButtonStyles";
import { useDispatch } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import UserAccessNew from "../MerchantPortalUI/UserAccessNew";
import { adminProfile } from "../../static-models/AdminProfile";
import PromotionsTab from "../MerchantPortalUI/PromotionsTab";
import Tooltip from "@mui/material/Tooltip";
import ViewMerchantDetailsNew from "../merchant/ViewMerchantDetailsNew";
import DashboardNewUI from "../MerchantPortalUI/DashboardNewUI";
import { adminActions } from "../../redux/slices/adminSlice";
import { financeActions } from "../../redux/slices/financeSlice";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../../redux/slices/memberSlice";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { roleActions } from "../../redux/slices/roleSlice";
import { salesActions } from "../../redux/slices/SalesSlice";
import { shopUserActions } from "../../redux/slices/shopUserSlice";
import SalesListingDetails from "../finance/SalesListingDetails";
import {
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import InvalidUrl from "../../pages/InvalidUrl";
import { selectFeaturePermissions } from "../../redux/selectors/loginSelector";
import { sideMenuList } from "../../static-models/sidemenu";
import { NormalTextToSnakeCase } from "../AccessManagement/utils";
import AccessManageMent from "../AccessManagement/AccessManagement";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import useGetMerchants from "../../Hooks/merchant/useGetMerchants";
import FinanceReports from "../finance/FinanceReports";
import { getModulePermissions } from "../../util/permissions";

const Home: React.FunctionComponent = () => {
  const [merchantLog, setMechantLogo] = useState("");
  const dispatch = useDispatch();
  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [updateProfile, setUpdateProfile] = useState(false);
  const [merchant, setMerchant] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const groups = localStorage.getItem("groups");
  const redirect_promotions_Strapi =
    process.env.REACT_APP_PROMOTIONS_STRAPI_LINK;
  const redirect_flashSale_CRM = process.env.REACT_APP_FLASHSALE_CRM_LINK;
  const redirect_rewards_CRM = process.env.REACT_APP_REWARDS_CRM_LINK;
  const userRoleGroup = groups ? JSON.parse(groups) : [];
  const theme = useTheme();
  const status = filterConstants.Active;
  const data = useAppSelector(selectFeaturePermissions);
  const finalPermission: any[] = data && Object.keys(data);
  const firstElement = sideMenuList?.filter((menu) =>
    finalPermission?.includes(NormalTextToSnakeCase(menu?.module))
  );
  const navigateModule = firstElement?.length ? firstElement[0]?.module : "";
  const activePathIndex = firstElement?.findIndex(
    (item) => item.module === navigateModule
  );
  const [activeIndex, setActiveIndex] = useState<string>("");
  const { pathname } = useLocation();
  const { fetchMerchantList } = useGetMerchants();

  useEffect(() => {
    setActiveIndex(pathname);
  }, [pathname]);

  const profile = useAppSelector((state: any) => {
    const userProfile: any = state.persistReducers.login;
    return {
      firstName: userProfile?.firstName,
      lastName: userProfile?.lastName,
      email: userProfile?.email,
    };
  });
  const userRole = useAppSelector(
    (state: any) => state.persistReducers.login.userRole
  );
  const firstName = useAppSelector(
    (state: any) => state.persistReducers.login.firstName
  );
  const lastName = useAppSelector(
    (state: any) => state.persistReducers.login.lastName
  );
  useEffect(() => {
    if (userRoleGroup?.find((role: any) => role.includes("merchant"))) {
      setMerchant(true);
    }
    if (userRoleGroup?.includes(constant.adminRole)) {
      fetchMerchantList && fetchMerchantList();
    }
  }, []);
  let { selectedMerchantDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  selectedMerchantDetails = selectedMerchantDetails
    ? selectedMerchantDetails
    : {};
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const loginName = localStorage.getItem("loginName");
  useEffect(() => {
    if (constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN) {
      const { merchant_logo } = selectedMerchatDetails;
      setMechantLogo(merchant_logo);
    }
  }, []);

  const name = merchant ? loginName : `${firstName} ${lastName}`;
  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };

  const handleButtonClick = (path: string) => {
    if (constant.domain !== process.env.REACT_APP_MERCHANT_DOMAIN)
      updatePermission();
    setActiveIndex(path);
  };

  const updatePermission = async () => {
    // const permissions = await getUserPermission();
    // dispatch(loginCognitoActions.updatePermission(permissions));
  };

  const handleLogout = async () => {
    setLoading(true);
    HandleSignOut();
    resetPersistStates();
    HandleSignOut();
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  const getRedirectionLink = (menuPath: any) => {
    switch (menuPath) {
      case "/flashSale_redirection":
        return redirect_flashSale_CRM;
      case "/rewards_redirection":
        return redirect_rewards_CRM;
      case "/promotions_redirection":
        return redirect_promotions_Strapi;
    }
  };

  const HandleSignOut = async () => {
    setLoading(true);
    try {
      const logoutWindow = window.open(
        "https://sgcrm.cc.capillarytech.com/arya/api/v1/auth/logout",
        "_blank"
      );

      if (logoutWindow) {
        setTimeout(() => {
          logoutWindow.close();
        }, 1);
      } else {
        console.error("Error: Unable to open logout window");
      }
    } catch (err) {
      console.error("Error while initiating logout:", err);
    } finally {
      setLoading(false);
    }
  };

  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );
  const getMemberRedemptionPermissionsModule = useAppSelector(
    (state: any) => state.persistReducers.login.featurePermissions
  );
  const userType = useAppSelector(
    (state: any) => state.persistReducers.login.userTypeGroup
  );

  const getIcon = (icon: string) => {
    switch (icon) {
      case "dashboard":
        return <DashboardIcon sx={{ pr: 2 }} />;
      case "members":
        return <PeopleAltIcon sx={{ pr: 2 }} />;
      case "merchants":
        return <StorefrontIcon sx={{ pr: 2 }} />;
      case "receipts":
        return <ReceiptLongIcon sx={{ pr: 2 }} />;
      case "pendingReceipts":
        return <HourglassEmptyIcon sx={{ pr: 2 }} />;
      case "finance":
        return <MonetizationOnIcon sx={{ pr: 2 }} />;
      case "finance-reports":
        return <AssessmentIcon sx={{ pr: 2 }} />;
      case "admin":
        return <AdminPanelSettingsIcon sx={{ pr: 2 }} />;
      case "crm":
        return <WebStoriesIcon sx={{ pr: 2 }} />;
      case "flashsale":
        return <ShoppingCartCheckoutIcon sx={{ pr: 2 }} />;
      case "deals":
        return <HandshakeIcon sx={{ pr: 2 }} />;
      case "events":
        return <EventAvailableIcon sx={{ pr: 2 }} />;
      case "promotions":
        return <Promotions style={{ paddingRight: "1rem" }} />;
      case "campaign":
        return <CampaignIcon sx={{ pr: 2 }} />;
      case "configuration":
        return <Configuration style={{ paddingRight: "1rem" }} />;
      case "settings":
        return <SettingsIcon sx={{ pr: 2 }} />;
      case "feedback":
        return <FeedbackIcon sx={{ pr: 2 }} />;
      case "sales":
        return <LocalOfferIcon sx={{ pr: 2 }} />;
      case "voucherTransaction":
        return <ReceiptIcon sx={{ pr: 2 }} />;
      case "physicalVouchers":
        return <AccountBalanceWalletIcon sx={{ mr: 2 }} />;
      case "eVoucher":
        return <AddCardIcon sx={{ mr: 2 }} />;
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleCollapseToggle = () => {
    setIsCollapsed((prevState) => !prevState);
  };

  // routes permissions
  const { getUserPermission: getMemberPermissions } = usePermissionGetter(
    permissionsConstants.members,
    permissionsConstants.members_search
  );
  const { getUserPermission: getMemberCorporateLogs } = usePermissionGetter(
    permissionsConstants.members,
    permissionsConstants.corporate_member_logs
  );
  const { getUserPermission: getMemberReceiptPermissions } =
    usePermissionGetter(
      permissionsConstants.members,
      permissionsConstants.receipts
    );
  const {
    getUserPermission: getMerchantPermissions,
    hasModulePermission: hasMerchantPermission,
  } = usePermissionGetter(
    permissionsConstants.merchant,
    permissionsConstants.merchants
  );
  const { getUserPermission: getAccessManagementPermissions } =
    usePermissionGetter(
      permissionsConstants.admin,
      permissionsConstants.access_management
    );
  const { getUserPermission: getSalesOfVoucher } = usePermissionGetter(
    permissionsConstants.sale_of_voucher,
    permissionsConstants.sales
  );
  const { getUserPermission: getSalesListing } = usePermissionGetter(
    permissionsConstants.finance,
    permissionsConstants.sales_listing
  );
  const { getUserPermission: getShopUserPermissions } = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.shop_user
  );
  const { getUserPermission: getUserPermissions } = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.user
  );
  const { getUserPermission: getReceiptsPermissions } = usePermissionGetter(
    permissionsConstants.receipts,
    permissionsConstants.receipts
  );
  const { getUserPermission: getPhysicalVoucherPermissions } =
    usePermissionGetter(
      permissionsConstants.physical_voucher,
      permissionsConstants.physical_voucher
    );
  const { getUserPermission: getPhysicalVoucherReimPermissions } =
    usePermissionGetter(
      permissionsConstants.physical_voucher_reimbursement,
      permissionsConstants.physical_voucher_reimbursement
    );

  const { getUserPermission: getFinancePhysicalVoucherReimPermissions } =
    usePermissionGetter(
      permissionsConstants.finance,
      permissionsConstants.reimbursment_physical_voucher
    );

  const { getUserPermission: getMemberRedemptionPermissions } =
    usePermissionGetter(
      permissionsConstants.member_redemption,
      permissionsConstants.receipts
    );
  const { getUserPermission: getAdminVoucherTransactionPermissions } =
    usePermissionGetter(
      permissionsConstants.voucher_transaction,
      permissionsConstants.voucher_transaction
    );
  const { getUserPermission: getFraudDetectPermissions } = usePermissionGetter(
    permissionsConstants.receipts,
    permissionsConstants.fraud_detect_configuration
  );
  const { getUserPermission: getEVoucherReimPermissions } = usePermissionGetter(
    permissionsConstants.evoucher_reimbursement,
    permissionsConstants.evoucher_reimbursement
  );
  const { getUserPermission: getFinanceEVoucherReimPermissions } =
    usePermissionGetter(
      permissionsConstants.finance,
      permissionsConstants.reimbursment_evoucher
    );
  const { hasModulePermission: hasDashboardPermisison } = usePermissionGetter(
    permissionsConstants.dashboard,
    permissionsConstants.dashboard
  );
  const { getUserPermission: getMerchantAccessUserPermissions } =
    usePermissionGetter(
      permissionsConstants.user_access,
      permissionsConstants.user_access
    );
  const {
    getUserPermission: getMerchantRewardsPermissions,
    hasModulePermission: hasMerchantRewardsPermission,
  } = usePermissionGetter(
    permissionsConstants.rewards,
    permissionsConstants.all_rewards
  );
  const {
    getUserPermission: getFlashSalesPermissions,
    hasModulePermission: hasFlashSalePermission,
  } = usePermissionGetter(
    permissionsConstants.flash_sale,
    permissionsConstants.all_flash_sales
  );
  const { getUserPermission: getMerchantPhysicalVoucher } = usePermissionGetter(
    permissionsConstants.physical_voucher_reimbursement,
    permissionsConstants.physical_voucher_reimbursement
  );
  const { getUserPermission: getMerchantEVoucherPermissions } =
    usePermissionGetter(
      permissionsConstants.evoucher_reimbursement,
      permissionsConstants.evoucher_reimbursement
    );
  const { userPermission: financeReportPermission } = usePermissionGetter(
    permissionsConstants.finance_reports,
    permissionsConstants.finance_reports
  );
  const {
    getUserPermission: getMerchantPromotionsPermissions,
    hasModulePermission: hasPromotionModule,
  } = usePermissionGetter(
    permissionsConstants.promotions,
    permissionsConstants.promotions
  );

  return (
    <Grid display={"flex"} flexDirection={"column"} height={"100vh"}>
      <Drawer
        anchor={"right"}
        open={showProfile}
        onClose={() => {
          setUpdateProfile(false);
          setShowProfile(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
          zIndex: 9999,
        }}
      >
        <Grid
          width={"698px"}
          height={"100%"}
          p={4}
          sx={{ borderRadius: "16px 0 0 16px" }}
        >
          {updateProfile ? (
            <Grid
              height={"100%"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
            >
              <Grid display={"flex"} flexDirection={"column"}>
                <Grid
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  width={"100%"}
                >
                  <Grid display={"flex"}>
                    <Button onClick={() => setUpdateProfile(false)}>
                      <ArrowBackIosIcon
                        sx={{ color: theme?.color?.newFilterGrey }}
                      />
                    </Button>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontWeight: "600",
                        fontSize: theme.font?.fontSize.large,
                      }}
                    >
                      Update Profile
                    </Typography>
                  </Grid>
                  <IconButton
                    onClick={() => setShowProfile(false)}
                    sx={{ justifySelf: "end" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <Grid alignSelf={"center"}>
                  <Grid display={"flex"} gap={3} mt={8}>
                    <Grid>
                      <Typography
                        sx={{ fontFamily: theme.font?.fontFamily.primary }}
                      >
                        First Name
                      </Typography>
                      <TextField
                        size="small"
                        value={profile?.firstName ? profile?.firstName : "-"}
                        InputProps={{
                          readOnly: true,
                        }}
                      ></TextField>
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{ fontFamily: theme.font?.fontFamily.primary }}
                      >
                        Last Name
                      </Typography>
                      <TextField
                        size="small"
                        value={profile?.lastName ? profile?.lastName : "-"}
                        InputProps={{
                          readOnly: true,
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                  <Grid mt={4}>
                    <Typography
                      sx={{ fontFamily: theme.font?.fontFamily.primary }}
                    >
                      Email
                    </Typography>
                    <TextField
                      size="small"
                      value={profile?.email ? profile?.email : "-"}
                      InputProps={{
                        readOnly: true,
                      }}
                    ></TextField>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                borderTop={theme.border?.newGreyBorder}
                display={"flex"}
                gap={2}
                px={4}
                pt={6}
                justifyContent={"end"}
              >
                <Button
                  sx={{ ...buttonStyles.outlinedSecondary, width: "30%" }}
                  onClick={() => setUpdateProfile(false)}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ ...buttonStyles.containedSecondary, width: "30%" }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid display={"flex"} flexDirection={"column"} gap={6}>
              <Grid
                display={"flex"}
                flex={1}
                alignItems={"center"}
                justifyContent={"space-between"}
                width={"100%"}
                px={2}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontWeight: "600",
                    fontSize: theme.font?.fontSize.large,
                  }}
                >
                  My Profile
                </Typography>
                <IconButton onClick={() => setShowProfile(false)}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid>
                <Grid
                  border={theme.border?.newGreyBorder}
                  sx={{ background: theme.color?.newGreyBackground }}
                  borderRadius={2}
                  p={4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={6}
                >
                  <Grid
                    display={"flex"}
                    justifyContent={"space-evenly"}
                    gap={1}
                  >
                    <Grid width={"20%"}>
                      <Avatar
                        src={
                          constant.domain ===
                          process.env.REACT_APP_MERCHANT_DOMAIN
                            ? merchantLog
                            : adminProfile.adminProfileImage
                        }
                        sx={{ height: "64px", width: "64px" }}
                      ></Avatar>
                    </Grid>
                    <Grid
                      display={"flex"}
                      flexDirection={"column"}
                      gap={1}
                      width={"30%"}
                    >
                      <Typography
                        sx={{
                          color: theme.color?.newGreyText,
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableBody,
                        }}
                      >
                        Name
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableBody,
                        }}
                      >
                        {name}
                      </Typography>
                    </Grid>
                    <Grid
                      display={"flex"}
                      flexDirection={"column"}
                      gap={1}
                      width={"40%"}
                    >
                      <Typography
                        sx={{
                          color: theme.color?.newGreyText,
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableBody,
                        }}
                      >
                        Email
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableBody,
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {profile?.email}
                      </Typography>
                    </Grid>
                    <Grid
                      display={"flex"}
                      flexDirection={"column"}
                      gap={1}
                      width={"20%"}
                    >
                      <Typography
                        sx={{
                          color: theme.color?.newGreyText,
                          fontFamily: theme.font?.fontFamily.primary,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          fontSize: theme.font?.fontSize.tableBody,
                        }}
                      >
                        Status
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "center",
                          minHeight: "1rem",
                          width: "80%",
                          color:
                            status === filterConstants.Active
                              ? theme?.color?.success
                              : theme?.color?.error,
                          border:
                            status === filterConstants.Active
                              ? `${theme?.border?.xsmall} ${theme?.color?.success}`
                              : `${theme?.border?.xsmall} ${theme?.color?.error}`,
                          backgroundColor:
                            status === filterConstants.Active
                              ? theme?.color?.successLight
                              : theme.color?.errorLight,
                          borderRadius: "12.52px",
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableHeader,
                        }}
                      >
                        {status}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid display={"flex"} justifyContent={"end"}>
                    <Button
                      sx={{ ...buttonStyles.outlinedDanger }}
                      onClick={handleLogout}
                    >
                      Logout
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Drawer>
      <Grid
        flex={1}
        sx={{ zIndex: 2 }}
        position={"sticky"}
        top={0}
        width={"100%"}
      >
        <Header showProfileTrue={setShowProfile} />
      </Grid>

      <Grid flex={9} display={"flex"} sx={{ overflow: "auto" }}>
        <Drawer
          variant="permanent"
          sx={{
            zIndex: 1,
            width: isCollapsed ? "6vw" : "14vw",
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: isCollapsed ? "6vw" : "14vw",
              boxSizing: "border-box",
              backgroundColor: theme.color?.background,
              overflowX: "hidden",
              height: "100%",
            },
          }}
        >
          <Grid
            sx={{
              height: "100%",
              backgroundColor: theme.color?.background,
              pt: "22vh",
              overflow: "visible",
            }}
          >
            {finalPermission
              ? sideMenuList
                  ?.filter((menu) =>
                    finalPermission?.includes(
                      NormalTextToSnakeCase(menu.module)
                    )
                  )
                  .map((menu, index) => {
                    const isActive = pathname === menu.path;

                    return (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          margin: 0,
                          padding: 0,
                        }}
                        pr={2}
                      >
                        <Tooltip
                          title={isCollapsed ? menu.text : ""}
                          placement="right"
                          arrow
                        >
                          <Link to={menu.path}>
                            <Button
                              sx={{
                                textAlign: "left",
                                paddingLeft: isCollapsed ? "2vw" : "1.5vw",
                                color: isActive
                                  ? theme.color?.sideMenuNewActive
                                  : theme.color?.sideMenuNewInActive,
                                justifyContent:
                                  theme.alignment?.justifyContent?.left,
                                textTransform: "none",
                                width: "100%",
                                backgroundColor: isActive
                                  ? theme.color?.sideMenuBackground
                                  : null,
                                borderRight: isActive
                                  ? `2px solid ${theme.color?.primary}`
                                  : null,
                                borderRadius: 0,
                                fontFamily: theme.font?.fontFamily.primary,
                              }}
                              onClick={() => {
                                if (menu.path.includes("redirection")) {
                                  window.open(
                                    getRedirectionLink(menu.path),
                                    "_blank"
                                  );
                                } else {
                                  handleButtonClick(menu.path);
                                }
                                setActiveIndex(menu.path);
                              }}
                            >
                              {isCollapsed && menu?.icon ? (
                                getIcon(menu.icon)
                              ) : (
                                <>
                                  {menu?.icon && (
                                    <Grid
                                      display={"flex"}
                                      alignItems={"center"}
                                    >
                                      {getIcon(menu.icon)}
                                    </Grid>
                                  )}
                                  {menu.text}
                                </>
                              )}
                            </Button>
                          </Link>
                        </Tooltip>
                      </Grid>
                    );
                  })
              : null}
          </Grid>
        </Drawer>
        <Grid
          display={"flex"}
          justifyContent="end"
          alignItems={"start"}
          mb={1}
          mt={"2vh"}
          zIndex={5}
          ml={-2.5}
        >
          <IconButton
            aria-label="expand"
            onClick={handleCollapseToggle}
            sx={{
              mr: "-20px",
            }}
          >
            {isCollapsed ? (
              <ArrowForwardIosOutlinedIcon
                sx={{
                  color: theme.color?.primary,
                  borderRadius: 50,
                  background: theme.color?.background,
                  border: theme.border?.smallGrey,
                  height: "22px",
                  width: "22px",
                  padding: 0.4,
                  boxSizing: "border-box",
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                }}
              />
            ) : (
              <ArrowBackIosNewOutlinedIcon
                sx={{
                  color: theme.color?.primary,
                  borderRadius: 50,
                  border: theme.border?.smallGrey,
                  height: "22px",
                  width: "22px",
                  padding: 0.4,
                  background: theme.color?.background,
                  boxSizing: "border-box",
                  boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                }}
              />
            )}
          </IconButton>
        </Grid>
        <Grid
          sx={{ background: theme.color?.greyBackground, overflowY: "scroll" }}
          width={isCollapsed ? `94vw` : "86vw"}
          p={4}
          py={2}
        >
          <Routes>
            <Route path="*" element={<InvalidUrl />} />
            <Route element={<Admin />}>
              {getMemberPermissions("read") && (
                <Route path="/members" element={<ViewMember />} />
              )}
              {getMemberCorporateLogs("read") && (
                <Route path="/corporate" element={<CorporateLogs />} />
              )}
              {getMemberCorporateLogs("read") && (
                <Route
                  path="/corporate/:corporateId"
                  element={<CorporateLogs />}
                />
              )}
              {getMemberPermissions("create") && (
                <Route
                  path="/addMember"
                  element={
                    <AddMemberForm
                      initialFormData={initialFormValuesNew}
                      type="Add"
                    />
                  }
                />
              )}
              {getMemberPermissions("read") && (
                <Route path="/viewMember" element={<ViewMemberDetails />} />
              )}
              {getMemberReceiptPermissions("read") && (
                <Route
                  path="/viewMember/:receiptsId"
                  element={<ViewMemberDetails />}
                />
              )}
              {hasMerchantPermission && (
                <Route path="/viewMerchant" element={<ViewMerchant />} />
              )}
              {getAccessManagementPermissions("read") && (
                // <Route path="/roles" element={<TabsComponent />} />
                <Route path="/roles" element={<AccessManageMent />} />
              )}
              {getMemberRedemptionPermissionsModule.member_redemption && (
                <Route
                  path="/memberRedemption"
                  element={<MemberRedemption />}
                />
              )}
              {getMemberRedemptionPermissionsModule.member_redemption && (
                <Route
                  path="/search/memberRedemption"
                  element={<ViewMember />}
                />
              )}
              {getSalesOfVoucher("read") && (
                <Route path="/sales" element={<Sales />} />
              )}
              {getSalesOfVoucher("read") && (
                <Route path="/search/sales" element={<ViewMember />} />
              )}
              {getSalesOfVoucher("read") && (
                <Route path="/salesReports" element={<SalesReports />} />
              )}
              <Route
                path="/redeembox"
                element={<RedeemCheckBox id={[]} EVoucher={[]} />}
              />
              {getMerchantPermissions("create") && (
                <Route
                  path="/addMerchant"
                  element={
                    <AddMerchant initialFormData={AddMerchantData} type="Add" />
                  }
                />
              )}

              {getMerchantPermissions("create") && (
                <Route
                  path="/viewMerchantDetails/:merchantId"
                  element={<ViewMerchantDetailsNew />}
                />
              )}
              {getSalesListing("read") && (
                <Route
                  path="/salesListingDetails/:orderId"
                  element={<SalesListingDetails />}
                />
              )}

              <Route
                path="/profile"
                element={<Profile initialFormData={UpdateAdminData} />}
              />
              {getMemberRedemptionPermissionsModule.finance && (
                <Route path="/finance" element={<Finance />} />
              )}
              {financeReportPermission.read && (
                <Route path="/finance-reports" element={<FinanceReports />} />
              )}
              {getMemberRedemptionPermissionsModule.admin && (
                <Route path="/admin" element={<AdminSidebar />} />
              )}
              {getShopUserPermissions("read") && (
                <Route
                  path="/admin/SU/:shopuserId"
                  element={<AdminSidebar />}
                />
              )}
              {getUserPermissions("read") && (
                <Route path="/admin/CU/:userId" element={<AdminSidebar />} />
              )}
              <Route path="/role" element={<Role />} />
              {getUserPermissions("create") && (
                <Route
                  path="/adduser"
                  element={<AddUser initialFormData={AddAdminData} />}
                />
              )}
              {getShopUserPermissions("create") && (
                <Route path="/addshopuser" element={<AddShopUser />} />
              )}
              {getUserPermissions("read") && (
                <Route
                  path="/viewuserprofile/:userId"
                  element={<ViewUserProfile />}
                />
              )}
              {getShopUserPermissions("read") && (
                <Route
                  path="/viewshopuser/:shopuserId"
                  element={<ViewShopUser />}
                />
              )}

              <Route path="/promotions_redirection" element={<Redirected />} />
              <Route path="/rewards_redirection" element={<Redirected />} />
              <Route path="/flashSale_redirection" element={<Redirected />} />

              {getReceiptsPermissions("read") && (
                <Route path="/receipts" element={<ListReceipt />} />
              )}
              {getReceiptsPermissions("read") &&
                constant.domain !== process.env.REACT_APP_MERCHANT_DOMAIN && (
                  <Route path="/pending-receipts" element={<PendingReceipt />} />
                )}
              {getReceiptsPermissions("read") &&
                constant.domain !== process.env.REACT_APP_MERCHANT_DOMAIN && (
                  <Route
                    path="/pending-receipts/:receiptsId"
                    element={<PendingReceipt />}
                  />
                )}
              {getPhysicalVoucherPermissions("read") && (
                <Route
                  path="/uploadVoucher"
                  element={<PhysicalVoucherUpload />}
                />
              )}
              {getPhysicalVoucherPermissions("read") && (
                <Route
                  path="/uploadVoucher/:voucherDetails"
                  element={<PhysicalVoucherUpload />}
                />
              )}
              {getPhysicalVoucherPermissions("create") && (
                <Route
                  path="/addphysicalvoucher"
                  element={<AddPhysicalVoucher />}
                />
              )}

              {getAdminVoucherTransactionPermissions("read") && (
                <Route
                  path="/adminVoucherTransaction"
                  element={<AdminVoucherTransaction />}
                />
              )}

              {getReceiptsPermissions("create") && (
                <Route path="/addReceipt" element={<AddReceipt />} />
              )}
              <Route path="/import-receipt" element={<ImportReceipt />} />
              {getReceiptsPermissions("update") && (
                <Route path="/receipts/:receiptsId" element={<ListReceipt />} />
              )}
              {getMemberRedemptionPermissions("update") && (
                <Route
                  path="/memberRedemption/:receiptsId"
                  element={<MemberRedemption />}
                />
              )}
              {(getEVoucherReimPermissions("read") ||
                getFinanceEVoucherReimPermissions("read")) && (
                <Route
                  path="/e-voucherDetails/:voucherId"
                  element={<ViewReportDetails />}
                />
              )}
              {(getPhysicalVoucherReimPermissions("read") ||
                getFinancePhysicalVoucherReimPermissions("read")) && (
                <Route
                  path="/p-voucherDetails/:PVoucherId"
                  element={<ViewPVReportDetails />}
                />
              )}

              {getFraudDetectPermissions("read") && (
                <Route
                  path="/fraudDetectSetting"
                  element={<FraudDetectSettings />}
                />
              )}
              {getMemberCorporateLogs("read") && (
                <Route
                  path="/viewCorporateUser/:corporateId"
                  element={<ViewCorporateUser />}
                />
              )}
              {getMerchantEVoucherPermissions("read") && (
                <Route
                  path="/voucherTransaction"
                  element={<EVoucherTransaction />}
                />
              )}
              {hasDashboardPermisison && (
                <Route path="/merchantDashboard" element={<DashboardNewUI />} />
              )}
              {getMerchantAccessUserPermissions("read") && (
                <Route path="/userAccess" element={<UserAccessNew />} />
              )}
              {getMerchantAccessUserPermissions("create") && (
                <Route path="/adduseraccess" element={<AddUserAccess />} />
              )}
              {getMerchantAccessUserPermissions("update") && (
                <Route
                  path="/updateuseraccess/:userAccessId"
                  element={<UpdateUserAccess />}
                />
              )}

              {hasMerchantRewardsPermission && (
                <Route path="/deals" element={<DealsNew />} />
              )}
              {hasFlashSalePermission && (
                <Route path="/flashsale" element={<FlashSaleNew />} />
              )}
            </Route>

            {getMerchantPhysicalVoucher("read") && (
              <Route
                path="/physicalVoucher"
                element={<PhysicalEvoucherNew />}
              />
            )}
            {getMerchantEVoucherPermissions("read") && (
              <Route path="/eVoucher" element={<EvoucherTab />} />
            )}

            <Route
              path="/newProfile"
              element={<NewProfile initialFormData={UpdateAdminData} />}
            />
            <Route
              path="/updateProfile"
              element={<UpdateProfile initialFormData={UpdateAdminData} />}
            />
            {hasPromotionModule && (
              <Route path="/promotions" element={<PromotionsTab />} />
            )}
            {getMerchantPromotionsPermissions("create") && (
              <Route path="/addPromotions" element={<AddPromotionsForm />} />
            )}
          </Routes>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Home;
